import { Row, Col, Modal, Select, message, Input } from 'antd';
import React, { Component } from 'react';
import _ from 'lodash';
import PFDFieldSample from './PFDFieldSample';
import PFDCategorySample from './PFDCategorySample';
import PFDDateSample from './PFDDateSample';
import pfdStore from './pendingFieldDialogStore';
import { HelpText } from '../../../views/typography';
import Ellipsed from '../../../views/Ellipsed';


const COMPS = [
  '=',
  '>=',
  '>',
  '<=',
  '<',
];

export default class PendingFieldDialog extends Component {
  constructor(props) {
    super(props);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.store = pfdStore(props);
    this.state = {};
  }

  handleOk() {
    const { value, pendingField } = this.store.state;
    if (value === '' && pendingField.type !== 'varchar') {
      message.error(`You cannot have an empty value for a property of type ${pendingField.type}`);
      return;
    }
    this.props.confirmPendingFieldDialog(true, value, this.store.state.comp);
  }

  handleCancel() {
    this.props.confirmPendingFieldDialog(false);
  }


  componentDidMount() {
    this._stateSub = this.store.subscribe((store) => {
      this.setState(state => ({ ...state, ...store.state }));
    }, (err) => {
      console.log('error on store: ', err);
      this.store.restart();
    }, () => {
      console.log('end of subscribe');
    });

    this.store.actions.fetchSample();
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this._stateSub) {
      this._stateSub.unsubscribe();
    }
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (prevProps.pendingField !== this.props.pendingField) {
      this.store.actions.reset();
      this.store.actions.setPendingField(this.props.pendingField);
      this.store.actions.fetchSample();
    }
    if (prevProps.pendingFieldTarget !== this.props.pendingFieldTarget) {
      this.store.actions.setPendingFieldTarget(this.props.pendingFieldTarget);
    }
    return null;
  }

  render() {
    const { showPendingFieldDialog } = this.props;
    const {
      comp, value, pendingField, pendingFieldTarget, ascending = true,
    } = this.store.state;
    if (!pendingField) {
      return '';
    }
    let parent = pendingField.parent;
    if (parent.name === 'fields') {
      parent = '';
    }

    let Sample = PFDFieldSample;
    if (parent) {
      switch (parent.name) {
        case 'categories':
          Sample = PFDCategorySample;
          break;

        case 'fields':
          Sample = PFDFieldSample;
          break;
      }
    }
    if (pendingField.type === 'datetime') {
      Sample = PFDDateSample;
    }

    let inputType = 'text';

    switch (pendingField.type) {
      case 'integer':
        inputType = 'number';
        break;

      case 'int':
        inputType = 'number';
        break;

      case 'float':
        inputType = 'number';
        break;

      case 'datetime':
        inputType = 'text';
        break;

      default:
        inputType = 'text';
    }

    return (<Modal
      width={650}
      title={<Ellipsed width={300}>
        { `Append ${pendingField.toString(true)} to "${pendingFieldTarget}"`}
             </Ellipsed>
}
      visible={showPendingFieldDialog}
      onOk={this.handleOk}
      onCancel={this.handleCancel}
    >
      {pendingFieldTarget === 'where' ? (
        <React.Fragment>
          <Row>
            <Col span={10}>{pendingField.toString()}</Col>
            <Col span={2}>
              { (pendingField.type === 'text') ? '~' :
              <Select defaultValue={comp} onChange={this.store.actions.chooseComp}>
                {COMPS.map(c => <Select.Option value={c}>{c}</Select.Option>)}
              </Select>
              }
            </Col>
            <Col span={12}><Input value={value} type={inputType} onChange={this.store.actions.chooseValue} /></Col>
          </Row>
          <Row>
            <Col span={12} />
            <Col span={12}><HelpText>{pendingField.type}</HelpText></Col>
          </Row>
          { (pendingField.type === 'text') ? <HelpText>
            The only text field operator is &quot;~&quot;.
            this searches the text field for the value you enter.
                                             </HelpText> : ''}
          <Sample state={this.store.state} actions={this.store.actions} />
        </React.Fragment>
      ) : ''}
    </Modal>);
  }
}
